import type { MouseEvent } from 'react'

import type { LANG, WithLoadingState } from '@eshop/type'

import i18n from './i18n'
import css from './index.module.css'

import { MenuImageList } from '#/global/component/Menu/Image'
import { Pagination } from '#/global/component/Pagination/Pagination'

import linkTo from '#/global/helper/LinkTo'

export interface Category {
    alias?: string
    id: number
    image?: string
    parentId: number
    slug: string
    title: string
}

export type CategoryTypes = 'eshop' | 'rental'

interface Props {
    itemsCount: number
    lang: LANG
    list: Category[]
    onItemClick?: (event: MouseEvent<HTMLAnchorElement>, parameters: { code: string, slug: string }) => void
    page: number
    setPage: (page: number) => void
    type: CategoryTypes
}

export const CategoryList = ({ itemsCount, lang, list, loadingState, onItemClick, page, setPage, type }: WithLoadingState<Props>) => {
    const itemsPerPage = 20

    if (loadingState) {
        return (
            <div className={css.container} data-name="r-a-search r-category-list">
                <h3 className={`${css.title} loading`} />
                <div className={`${css.pagination} ${css.top} loading`} />
                <MenuImageList items={Array.from({ length: 8 }).fill({ loadingState: true }) as { loadingState: true }[]} />
            </div>
        )
    }

    const t = i18n[lang]

    return (
        <div className={css.container} data-name="r-a-search r-category-list">
            <h3>{t[type]}</h3>
            {itemsCount > itemsPerPage && (
                <div className={css.pagination}>
                    <Pagination itemsCount={itemsCount} itemsPerPage={itemsPerPage} page={page} setPage={setPage} />
                </div>
            )}
            <MenuImageList items={list.filter(Boolean).map(x => ({
                title: x.alias ?? x.title,
                image: x.image,
                link: linkTo(`category-${type}`, x.id, x.slug),
                onClick: event => onItemClick?.(event, { code: `${x.id}`, slug: x.slug }),
            }))}
            />
        </div>
    )
}
